// src/utilities/export/handleDownloadRunSummaryCSV.js

function formatTime(isoString) {
  if (!isoString) return '';
  try {
    return new Date(isoString).toTimeString().slice(0, 5); // "HH:MM"
  } catch {
    return '';
  }
}

function formatDay(isoString) {
  if (!isoString) return '';
  try {
    const d = new Date(isoString);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${day}.${month}`;
  } catch {
    return '';
  }
}

function formatDuration(startedAt, finishedAt) {
  if (!startedAt || !finishedAt) return '';
  try {
    const diffMs = new Date(finishedAt) - new Date(startedAt);
    if (diffMs < 0) return '';
    const totalSeconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return minutes > 0 ? `${minutes}m${seconds}s` : `${seconds}s`;
  } catch {
    return '';
  }
}

function resolveDeviceName(deviceId, deviceOptions) {
  if (!deviceId) return '';
  const device = deviceOptions.find((d) => d.value === deviceId);
  return device?.name || deviceId;
}

function escapeCsvField(value) {
  const str = String(value ?? '');
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function handleDownloadRunSummaryCSV(runs, deviceOptions) {
  const headers = [
    'scenario_name',
    'status',
    'devStatus',
    'started_at',
    'finished_at',
    'day',
    'device_name',
    'duration',
    'comments',
  ];

  const rows = runs.map((run) => [
    run.scenarioName || run.scenarioId || '',
    run.status || '',
    '',
    formatTime(run.startedAt),
    formatTime(run.finishedAt),
    formatDay(run.startedAt),
    resolveDeviceName(run.deviceId, deviceOptions),
    formatDuration(run.startedAt, run.finishedAt),
    '',
  ]);

  const csvContent = [headers, ...rows].map((row) => row.map(escapeCsvField).join(',')).join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 16);
  link.download = `run_summary_${ts}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
